// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__B-ign","row":"Node_row__YpUiQ","label":"Node_label__13i_W","footer":"Node_footer__1pw6X"};